import { render, staticRenderFns } from "./StudentAttendance.vue?vue&type=template&id=963c6e68"
import script from "./StudentAttendance.vue?vue&type=script&lang=js"
export * from "./StudentAttendance.vue?vue&type=script&lang=js"
import style0 from "./StudentAttendance.vue?vue&type=style&index=0&id=963c6e68&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports